module.exports = FormData;
//# sourceMappingURL=form-data.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popsicle/dist/lib/browser/form-data.js
// module id = 50
// module chunks = 0 1